/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PdsCrmSourceAccess_ConnectionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PdsCrmSourceAccess_ConnectionQuery = { organisationIntegration: { __typename: 'MissingCapabilities', missingCapabilities: Array<Types.Capabilities> } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationIntegrationResult', organisationIntegration?: { __typename: 'OrganisationIntegration', id: string } | null } };


export const PdsCrmSourceAccess_ConnectionDocument = gql`
    query PdsCrmSourceAccess_Connection {
  organisationIntegration(integrationId: pds_sync) {
    ... on OrganisationIntegrationResult {
      organisationIntegration {
        id
      }
    }
    ... on MissingCapabilities {
      missingCapabilities
    }
  }
}
    `;

/**
 * __usePdsCrmSourceAccess_ConnectionQuery__
 *
 * To run a query within a React component, call `usePdsCrmSourceAccess_ConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdsCrmSourceAccess_ConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdsCrmSourceAccess_ConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function usePdsCrmSourceAccess_ConnectionQuery(baseOptions?: Apollo.QueryHookOptions<PdsCrmSourceAccess_ConnectionQuery, PdsCrmSourceAccess_ConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdsCrmSourceAccess_ConnectionQuery, PdsCrmSourceAccess_ConnectionQueryVariables>(PdsCrmSourceAccess_ConnectionDocument, options);
      }
export function usePdsCrmSourceAccess_ConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdsCrmSourceAccess_ConnectionQuery, PdsCrmSourceAccess_ConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdsCrmSourceAccess_ConnectionQuery, PdsCrmSourceAccess_ConnectionQueryVariables>(PdsCrmSourceAccess_ConnectionDocument, options);
        }
export function usePdsCrmSourceAccess_ConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PdsCrmSourceAccess_ConnectionQuery, PdsCrmSourceAccess_ConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdsCrmSourceAccess_ConnectionQuery, PdsCrmSourceAccess_ConnectionQueryVariables>(PdsCrmSourceAccess_ConnectionDocument, options);
        }
export type PdsCrmSourceAccess_ConnectionQueryHookResult = ReturnType<typeof usePdsCrmSourceAccess_ConnectionQuery>;
export type PdsCrmSourceAccess_ConnectionLazyQueryHookResult = ReturnType<typeof usePdsCrmSourceAccess_ConnectionLazyQuery>;
export type PdsCrmSourceAccess_ConnectionSuspenseQueryHookResult = ReturnType<typeof usePdsCrmSourceAccess_ConnectionSuspenseQuery>;
export type PdsCrmSourceAccess_ConnectionQueryResult = Apollo.QueryResult<PdsCrmSourceAccess_ConnectionQuery, PdsCrmSourceAccess_ConnectionQueryVariables>;